<template>
  <div>
    <!-- <h5 class="info-text">{{$lang.titles.basic_settinsg}}</h5> -->

    <div class="md-layout">
      <!-- Serial number -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('SERIAL_NUMBER') }]">
          <label>Serial number</label>
          <md-input
            v-model="settings.serial_number"
            data-vv-name="SERIAL_NUMBER"
            type="text"
            name="SERIAL_NUMBER"
            v-validate="modelValidations.required"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('SERIAL_NUMBER')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Type -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('TYPE') }]">
          <label>Type</label>
          <md-input
            v-model="settings.type"
            data-vv-name="TYPE"
            type="text"
            name="TYPE"
            v-validate="modelValidations.required"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('TYPE')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- Connection -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CONNECTION') }]">
          <label>Connection</label>
          <md-select
            v-model="settings.connection"
            name="CONNECTION"
            v-validate="modelValidations.required"
          >
            <md-option value="0">3P4W</md-option>
            <md-option value="1">3P3W</md-option>
            <md-option value="2">2P3W</md-option>
            <md-option value="3">1P3W</md-option>
            <md-option value="4">1P2W</md-option>
          </md-select>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CONNECTION')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Input type -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('INPUT_TYPE') }]">
          <label>Input type</label>
          <md-select
            v-model="settings.input_type"
            name="INPUT_TYPE"
            v-validate="modelValidations.required"
          >
            <md-option value="0">LED</md-option>
            <md-option value="1">DISC/SO</md-option>
            <md-option value="2">SNAP.S</md-option>
          </md-select>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('INPUT_TYPE')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- Energy -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">
          <label>Energy</label>
          <md-select v-model="settings.energy" name="ENERGY" v-validate="modelValidations.required">
            <md-option value="0">Active</md-option>
            <md-option value="1">Reactive</md-option>
            <md-option value="2">Apparent</md-option>
          </md-select>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ENERGY')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Constant -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CONSTANT') }]">
          <label>Constant</label>
          <md-input
            v-model="settings.constant"
            type="text"
            name="CONSTANT"
            v-validate="modelValidations.only_number"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CONSTANT')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- Constant unit -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CONSTANT_UNIT') }]">
          <label>Constant unit</label>
          <md-select
            v-model="settings.constant_unit"
            name="CONSTANT_UNIT"
            v-validate="modelValidations.required"
          >
            <md-option value="0">i/kWh</md-option>
            <md-option value="1">i/Wh</md-option>
            <md-option value="2">i/Ws</md-option>
            <md-option value="3">i/kWs</md-option>
            <md-option value="4">kWh/i</md-option>
            <md-option value="5">Wh/i</md-option>
            <md-option value="6">Ws/i</md-option>
            <md-option value="7">kWs/i</md-option>
            <md-option value="8">MWh/i</md-option>
            <md-option value="9">i/MWh</md-option>
          </md-select>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CONSTANT_UNIT')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Constant type -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CONSTANT_TYPE') }]">
          <label>Constant type</label>
          <md-select
            v-model="settings.constant_type"
            name="CONSTANT_TYPE"
            v-validate="modelValidations.required"
          >
            <md-option value="0">Secondary</md-option>
            <md-option value="1">Primary</md-option>
          </md-select>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CONSTANT_TYPE')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- Producer -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-33 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('PRODUCER') }]">
          <label>Producer</label>
          <md-input
            v-model="settings.producer"
            type="text"
            name="PRODUCER"
            v-validate="modelValidations.none"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('PRODUCER')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Class -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-33 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CLASS') }]">
          <label>Class</label>
          <md-input
            v-model="settings.class"
            type="text"
            name="CLASS"
            v-validate="modelValidations.number_not_mandatory"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CLASS')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Year -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-33 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('YEAR') }]">
          <label>Year</label>
          <md-input
            v-model="settings.year"
            type="text"
            name="YEAR"
            v-validate="modelValidations.number_not_mandatory"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('YEAR')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      settings: {},
      defaultData: {
        serial_number: "",
        type: "",
        connection: "0",
        input_type: "0",
        energy: "0",
        constant: "1000",
        constant_unit: "5",
        constant_type: "0",
        producer: "",
        class: "",
        year: ""
      },

      modelValidations: {
        none: {},
        number_not_mandatory: {
          regex: /^[0-9]+$/
        },
        required: {
          required: true
        },
        only_number: {
          required: true,
          regex: /^[0-9]+$/
        }
      }
    };
  },
  created() {
    this.restartToDefault();
  },
  methods: {
    restartToDefault() {
      this.$validator.reset();
      this.errors.clear();
      this.settings = Object.assign({}, this.defaultData);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit("on-validated", true, this.settings);
        }
        return res;
      });
    }
  }
};
</script>

<style></style>